import {
  GetRealOrganizerEventsParams,
  GetManualViewsHistoryParams,
} from "@ac-expo/api-types";

export const acExpoQueryKeys = {
  all: ["ac-expo"] as const,
  realOrganizerEvents: (params?: GetRealOrganizerEventsParams) =>
    [...acExpoQueryKeys.all, "real-organizer-events", params] as const,
  allManualViewsHistory: () =>
    [...acExpoQueryKeys.all, "manual-views-history"] as const,
  manualViewsHistory: (filters?: GetManualViewsHistoryParams) =>
    [...acExpoQueryKeys.allManualViewsHistory(), filters] as const,
};
